<template>
	<div>
		<el-card>
			<div>
				<el-date-picker :unlink-panels="true" @change="getDate" value-format="yyyy-MM-dd" v-model="date1"
					type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
				</el-date-picker>
			</div>
			<el-table :data="tableData" border style="width: 100%;" height="750">
				<el-table-column type="index" label="序号" width="60" />
				<el-table-column prop="time" label="时间" width="180" />
				<el-table-column prop="czr" label="操作人" width="180" />
				<el-table-column prop="info" label="消息详情" />
			</el-table>
		</el-card>
	</div>
</template>
<script>
	import cx from '../api/xxcx'
	import zt from '../api/zt'
	export default {
		name: 'xxcx',
		data() {
			return {
				ztid: 0,
				tableData: [],
				ztlist: [],
				admin: '',
				date1: [],
				form: {
					ksrq: '',
					jsrq: '',
					ztid: sessionStorage.getItem('ztid'),
					zt: sessionStorage.getItem('ztmc') || ''
				}
			}
		},
		methods: {
			// 日期格式化输出 yyyy-MM-dd
			formatDate(date) {
				const year = date.getFullYear()
				let month = date.getMonth() + 1
				let day = date.getDate()
				month = month < 10 ? '0' + month : month
				day = day < 10 ? '0' + day : day
				return `${year}-${month}-${day}`
			},
			// 获取当月第一天
			getMonthStart() {
				const now = new Date()
				const start = new Date(now.getFullYear(), now.getMonth(), 1)
				return this.formatDate(start)
			},
			// 获取当月最后一天
			getMonthEnd() {
				const now = new Date()
				const end = new Date(now.getFullYear(), now.getMonth() + 1, 0)
				return this.formatDate(end)
			},
			async getzt() {
				this.ztlist = []
				let res = await zt.getAllzt()
				this.ztlist = res.data.data
			},
			async queryAllPushRecordInfo() {
				const {
					data: res
				} = await cx.queryAllPushRecordInfo(this.form)
				this.tableData = res.data
			},
			async queryPushRecordInfoByZtid1() {
				const {
					data: res
				} = await cx.queryPushRecordInfoByZtid1(this.form)
				this.tableData = res.data
			},
			getDate(e) {
				this.form.ksrq = e[0]
				this.form.jsrq = e[1]
				this.ifAdmin()
				console.log(e)
			},
			ifAdmin() {
				if (this.admin != "admin") {
					this.queryPushRecordInfoByZtid1()
				} else {
					this.queryAllPushRecordInfo()
				}
			}
		},
		mounted() {
			const ztid = sessionStorage.getItem('ztid')
			const dm = sessionStorage.getItem("dm")
			this.ztid = ztid
			this.admin = dm
			// 同步站点ID到查询表单
			this.form.ztid = ztid

			// 初始化计算当月起止日期
			const startDate = this.getMonthStart()
			const endDate = this.getMonthEnd()
			// 赋值给日期组件
			this.date1 = [startDate, endDate]
			// 统一走选择日期逻辑赋值form并查询，解决初始化无数据问题
			this.getDate([startDate, endDate])
		}
	}
</script>